export class Address {
  street: string;
  city: string;
  stateId: number;
  zip: string;
  county: string;
}
